import { render, staticRenderFns } from "./TestPrint.vue?vue&type=template&id=1290b6d2"
import script from "./TestPrint.vue?vue&type=script&lang=js"
export * from "./TestPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports